import { EstimatorInterface } from '../services/freak_estimator/Estimator';
import { ICloudStorage } from '../services/Database/CloudStorageService';
import { isInDebugMode } from '../util';
import { Storage } from '@ionic/storage';

/**
 * The environment is a place where services and shared dependencies between
 * models live.  They are made available to every model via dependency injection.
 */
export class Environment {
  cloudStorage: ICloudStorage;
  localStorage: Storage;
  api: EstimatorInterface;

  constructor(
    api: EstimatorInterface,
    cloudStorage: ICloudStorage,
    localStorage: Storage
  ) {
    // create each service
    if (isInDebugMode()) {
      // dev-only services
    }
    // always required services
    // Example for a shared api between models:
    this.api = api;
    this.cloudStorage = cloudStorage;
    this.localStorage = localStorage;
  }

  async setup() {
    // allow each service to setup
    if (isInDebugMode()) {
      // setup dev-only services
    }
    // setup required services
    // Example for a shared api between models:
    // await this.api.setup()
  }
}
